module.exports = __webpack_public_path__ + "img/2.3c5f590e.jpg";